import { render, staticRenderFns } from "./InvoiceTarifComponent.vue?vue&type=template&id=76318714&scoped=true&"
import script from "./InvoiceTarifComponent.vue?vue&type=script&lang=js&"
export * from "./InvoiceTarifComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76318714",
  null
  
)

export default component.exports